import actions from './actions';
import mutations from './mutations';
import { parseJSON } from '@/utils/helpers';

const technicalSupport = {
    namespaced: true,
    state: {
        cardData: parseJSON(localStorage.getItem('card')),
        reasons: [],
        cards: [],
        activeInfoNav: 'client-details',
        pagination: {
            page: 1,
            totalPages: 1
        },
        payments: [],
        fpPayments: [],
        clientInfo: {
            user: null,
            company: null,
            bonusSystem: null,
            orders: []
        },
        fpClientInfo: {
            cashback: null,
            balanceHistory: []
        }
    },
    mutations,
    actions
};

export default technicalSupport;
